// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ImportManagerialAccountingMutationVariables = Types.Exact<{
  url: Types.Scalars['Url']['input'];
  timezoneOffset: Types.Scalars['Long']['input'];
}>;

export type ImportManagerialAccountingMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'importManagerialAccounting'
>;

export const ImportManagerialAccountingDocument = /*#__PURE__*/ gql`
    mutation ImportManagerialAccounting($url: Url!, $timezoneOffset: Long!) {
  importManagerialAccounting(url: $url, timezoneOffset: $timezoneOffset)
}
    `;
export type ImportManagerialAccountingMutationFn = Apollo.MutationFunction<
  ImportManagerialAccountingMutation,
  ImportManagerialAccountingMutationVariables
>;

/**
 * __useImportManagerialAccountingMutation__
 *
 * To run a mutation, you first call `useImportManagerialAccountingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportManagerialAccountingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importManagerialAccountingMutation, { data, loading, error }] = useImportManagerialAccountingMutation({
 *   variables: {
 *      url: // value for 'url'
 *      timezoneOffset: // value for 'timezoneOffset'
 *   },
 * });
 */
export function useImportManagerialAccountingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportManagerialAccountingMutation,
    ImportManagerialAccountingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportManagerialAccountingMutation, ImportManagerialAccountingMutationVariables>(
    ImportManagerialAccountingDocument,
    options,
  );
}
export type ImportManagerialAccountingMutationHookResult = ReturnType<typeof useImportManagerialAccountingMutation>;
export type ImportManagerialAccountingMutationOptions = Apollo.BaseMutationOptions<
  ImportManagerialAccountingMutation,
  ImportManagerialAccountingMutationVariables
>;
